import {createContext, PropsWithChildren, useCallback, useMemo, useRef} from "react";
import {EventEmitter} from "nate-react-api-helpers";
import {TID} from "../../../../misc/scroller/Table";

const keyAllProps = "zzzz-all-props"

export function CheckboxObjProvider<T extends TID>(props: PropsWithChildren<{}>) {

    const obj = useRef<{[id: number]: T}>({})
    const lastSelectedIdRef = useRef<number|null>(null);
    const emit = useMemo(() => new EventEmitter<{id: number, key: any; value: boolean}>(), []);

    const listen = useCallback((raw: T, key: any, callback: (tf: boolean) => void) => {

        const getterSetter = getterSetterRef.current[key];
        const defaultGetter = (raw) => raw[key];
        const getter = getterSetter?.get || defaultGetter;

        const sub = emit.subscribe(value => {
            if(value.id === raw.id && (value.key === key || value.key === keyAllProps)) {
                if(obj.current.hasOwnProperty(raw.id)) {
                    callback(getter(obj.current[raw.id]));
                    return;
                }

                callback(getter(raw));
            }
        })

        if(obj.current.hasOwnProperty(raw.id)) {
            callback(getter(obj.current[raw.id]))
            return sub;
        }

        callback(getter(raw));
        return sub;
    }, [emit]);

    const selected = useCallback(() => {
        const list: T[] = [];
        console.log("selected", obj.current)

        for(let i in obj.current) {
            if(obj.current[i].id) {
                list.push(obj.current[i]);
            }
        }

        return list;
    }, []);

    const listenAll = useCallback((callback: (selected: T[]) => void) => {
        return emit.subscribe(() => callback(selected()));
    }, [emit, selected]);

    const set = useCallback((raw: T, key: string, value: boolean) => {
        if(!obj.current.hasOwnProperty(raw.id)) {
            obj.current[raw.id] = Object.assign({}, raw);
        }

        const getterSetter = getterSetterRef.current[key];
        if(getterSetter) {
            getterSetter.set(obj.current[raw.id], value);
        } else {
            obj.current[raw.id][key] = value;
        }

        lastSelectedIdRef.current = raw.id;
        emit.emit({id: raw.id, key: key, value: value});
    }, [emit]);

    const getterSetterRef = useRef<{[key: string]: GetterSetter}>({})

    const withGetterSetter = useCallback((key: any, pair: GetterSetter) => {
        getterSetterRef.current[key] = pair;
    }, [getterSetterRef]);

    const ctx = useMemo(() => ({
        lastSelectedId: lastSelectedIdRef,
        withGetterSetter,
        selected: obj,
        listen: listen,
        listenAll: listenAll,
        set: set,
        reset: () => {
            const cur = obj.current;
            obj.current = {};

            for(let i in cur) {
                emit.emit({id: cur[i].id, key: keyAllProps, value: false});
            }
        }
    }), [listen, listenAll, set, emit, withGetterSetter]);

    return (
        <CheckboxObjContext.Provider value={ctx}>
            {props.children}
        </CheckboxObjContext.Provider>
    );
}


export const CheckboxObjContext = createContext({
    lastSelectedId: {current: null as null | number},
    selected: {current: {}},
    withGetterSetter(raw: any, pair: GetterSetter) {},
    listen: (raw: any, key: any, callback: (tf: boolean) => void) => {
        return {
            cancel: () => {},
        }
    },
    listenAll: (callback: (selected: any[]) => void) => {
        return {
            cancel: () => {},
        }
    },
    set: (raw: any, key: any, value: boolean) => {},
    reset: () => {},
})

type GetterSetter = {
    get: (raw: any) => boolean,
    set: (raw: any, value: boolean) => void
}